import React from 'react';
import { DemoAccessComponent } from './demoAccess';
import { SubscriptionPurchaseComponent } from './subscriptionPurchase';

export function HeroComponent() {
    return (<section  id="profiti-section" className="hero" style={{ marginTop: 0, zIndex: 1 }} >
        <div className="container">
            <div className="row">
                <div className="col-12 col-md-6 col-lg-5 col-xl-4">
                    <div className="hero__content hero__content--second">
                        <div className="node node--hero">
                            <h3 className="node__title node__title--green"><b>PROFITI</b></h3>
                            <span className="node__line"><img src="/img/dodgers/dots--line-green.svg" alt="" /></span>
                            <ul className="node__list">
                                <li><i className="ti ti-circle-check"></i><b>Автоматичне створення угод</b> </li>
                                <li><i className="ti ti-circle-check"></i><b>Зміна мультиплікатора</b><br />
                                    <ul className='subList'>
                                        <li>по котируванню</li>
                                        <li>по інвестованій сумі</li>
                                        <li>по сумі просадки</li>
                                    </ul> </li>
                            </ul>
                            <ul className="node__list">
                                <li><i className="ti ti-circle-check"></i><b>Обмеження кількості створення угод</b> </li>
                                <li><i className="ti ti-circle-check"></i><b>Автоматичне збільшення суми угоди</b> </li>
                                <li><i className="ti ti-circle-check"></i><b>Автоматичне переведення в беззбиткову зону</b> </li>
                                <li><i className="ti ti-circle-check"></i><b>Налаштування умов для зміни мультиплікатора</b> </li>
                                <li><i className="ti ti-circle-check"></i><b>Нагадування про вихід новин</b> </li>
                                <li><i className="ti ti-circle-check"></i><b>Зміна мультиплікатора перед виходом новин</b> </li>
                            </ul>
                            <button className="form__btn" type="button" data-bs-target="#modal-subscription" data-bs-toggle="modal">Підписка</button>
                            <span className="stats__dodger stats__dodger--left stats__dodger--green"></span>
                            <span className="stats__dodger stats__dodger--right stats__dodger--green"></span>
                            <span className="screw screw--br"></span>
                            <span className="screw screw--bl"></span>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-7 col-xl-2"></div>
                <div className="col-12 col-lg-7 col-xl-6 d-flex flex-column align-items-end">
                    <div className="hero__content hero__content--first">
                        <h1 className="hero__title right"><strong>PROFITI</strong> <br />отримай <strong>повну</strong> версію для тесту.<br /> <strong> 3 дні безкоштовно.</strong></h1>
                    </div>
                    <br />
                    <div className="hero__content hero__content--second">
                        <button className="form__btn" type="button" data-bs-target="#modal-demo" data-bs-toggle="modal">Отримати доступ</button>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal modal--auto fade" id="modal-demo" tabIndex="-1" aria-labelledby="modal-apool" aria-hidden="true">
            <DemoAccessComponent />
        </div>
        <div className="modal modal--auto fade" id="modal-subscription" tabIndex="-1" aria-labelledby="modal-apool" aria-hidden="true">
            <SubscriptionPurchaseComponent />
        </div>
    </section>);
}